// extracted by mini-css-extract-plugin
export default {"container":"Nh","hidden":"Oh","column":"Ph","headline":"Qh"};